import { openElement, closeElement } from '/src/js/utils.js';
import { getLang, setLang } from '/src/js/l10n.js';

export {
  init,
}

let menuElement;
let menuCloseButtonElement;
let menuLinkElements;
let languageSelectLinks;

function init() {
  menuElement = document.getElementById('menu');
  menuCloseButtonElement = document.getElementById('menu-btn-close');
  menuLinkElements = document.querySelectorAll('.menu-link');
  languageSelectLinks = document.querySelectorAll('.language-select-link');

  // Add event listeners for menu buttons
  const menuButtonElement = document.getElementById('menu-btn-open');
  menuButtonElement.addEventListener('click', () => openElement(menuElement));
  menuCloseButtonElement.addEventListener('click', () => {
      closeElement(menuElement);
    }
  );
  menuLinkElements.forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      closeElement(menuElement);

      // Close all pages
      const pages = document.querySelectorAll('.page');
      pages.forEach(page => {
        closeElement(page);
      });

      // Close the transcription panel if open
      const transcriptionPanel = document.getElementById('transcription-panel');
      closeElement(transcriptionPanel);

      // Open the target element
      const target = element.getAttribute('data-page')
      openElement(document.getElementById(target));

      // Update the aria-expanded attributes on links
      menuLinkElements.forEach(link => {
        link.setAttribute('aria-expanded', 'false');
      });
      element.setAttribute('aria-expanded', 'true');
    })
  });

  // Add event listeners for language selection
  languageSelectLinks.forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      const newLang = element.getAttribute('lang');
      if (newLang !== getLang()) setLang(newLang);
      closeElement(menuElement);
    })
  });

  // Set the active language link based on the current language
  window.addEventListener('languagechange', () => {
    const newLang = getLang();

    // Update the current language link
    languageSelectLinks.forEach(element => {
      const lang = element.getAttribute('lang');
      if (lang === newLang) {
        element.classList.add('current');
        element.setAttribute('aria-selected', 'true');
      } else {
        element.classList.remove('current');
        element.removeAttribute('aria-selected');
      }
    });
  });
}
